(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frenzy-recommendation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:section:load', function(event) {
    frenzyScriptReload();
  });

  } catch(e) { console.error(e); }
})();
})();
